export const COLORS_v0 = {
    primary: '#20b2aa',
    secondary: '#219c90',
    dark: '#176d66',
    accent: '#d32f2f',
    textPrimary: '#2c3e50',
    textSecondary: '#7f8c8d',
    white: '#ffffff',
    lightGray: '#f5f5f5',
};

export const COLORS_v1 = {
    // Modern Blue Theme
    primary: '#2196F3',
    secondary: '#1976D2',
    dark: '#0D47A1',
    accent: '#FF4081',
    textPrimary: '#212121',
    textSecondary: '#757575',
    white: '#ffffff',
    lightGray: '#f5f5f5',
};

export const COLORS_v2 = {
    // Forest Green Theme
    primary: '#2E7D32',
    secondary: '#388E3C',
    dark: '#1B5E20',
    accent: '#FF6D00',
    textPrimary: '#263238',
    textSecondary: '#546E7A',
    white: '#ffffff',
    lightGray: '#f5f5f5',
};

export const COLORS_v3 = {
    // Purple Theme
    primary: '#7B1FA2',
    secondary: '#9C27B0',
    dark: '#4A148C',
    accent: '#FFC107',
    textPrimary: '#311B92',
    textSecondary: '#5E35B1',
    white: '#ffffff',
    lightGray: '#f5f5f5',
};

export const COLORS_v4 = {
    // Warm Orange Theme
    primary: '#FF5722',
    secondary: '#F4511E',
    dark: '#BF360C',
    accent: '#00BCD4',
    textPrimary: '#3E2723',
    textSecondary: '#8D6E63',
    white: '#ffffff',
    lightGray: '#f5f5f5',
};

export const COLORS_v_logo = {
    primary: '#e57373', // Lighter red
    secondary: '#e57373', // Lighter red
    dark: '#7f0000', // Darker red for depth
    accent: '#d32f2f', // Lighter red for highlights
    textPrimary: '#212121', // Very dark gray for text
    textSecondary: '#757575', // Muted gray for secondary text
    white: '#ffffff', // White for contrast
    lightGray: '#f5f5f5', // Light gray for backgrounds
};

export const COLORS = COLORS_v1;
